import { addHours } from 'date-fns';
import { Showing } from '../../types/showings';
import { isInFuture } from '../dates';
/** 'reserve': showings stay reservable until they start (no lead time)
 *
 * 4hr limit for creating showings
 * If openHouse with reservations/applictionIdList
 *
 * If you want all future showings and don't care about time limit for reservation, boolean is false
 */
const getFutureShowings = (showings: Showing[], timeLimitForShowing: 'reserve' | 'create' | false, ignoreWithReservedApplicationId = '') => showings.filter(({ startDate, applicationIds }: Showing) => {
    if (ignoreWithReservedApplicationId &&
        Array.isArray(applicationIds) &&
        applicationIds.includes(ignoreWithReservedApplicationId)) {
        return true;
    }
    // 'reserve': no lead time, invited showings stay reservable until they start
    let delayBy = 0;
    if (timeLimitForShowing === 'create') {
        delayBy = applicationIds ? 0 : 4;
    }
    const currentDatePlusDelay = addHours(new Date(), delayBy).valueOf();
    return isInFuture(Date.parse(startDate), currentDatePlusDelay);
});
export { getFutureShowings };
